module.exports = __webpack_public_path__ + "images/emoji/snowboarder.c42e5ab0cd06ae253100.png";